
import { useState } from "react";
import {
  Box,
  InputLabel,
  TextField,
} from "@mui/material";
import TransactionTable from "./TransactionTable";
import { useMediaQuery, useTheme } from "@mui/material";

export default function PartnerTransactionTab() {
  const [activeTab, setActiveTab] = useState("buy");
  const [refinery, setRefinery] = useState("all");
  const [metaltype, setMetal] = useState("all");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ✅ Mobile screen check

  return (
    <Box>
      <Box
        display="flex"
        flexDirection={isMobile ? "column" : "row"}
        justifyContent={isMobile ? "flex-start" : "center"}
        alignItems={isMobile ? "stretch" : "center"}
        gap={isMobile ? 1 : 2}
        mb={2}
        width="100%"
      >
        {/* Type Dropdown */}
        <TextField
          id="transactionType"
          label="Type"
          select
          value={activeTab}
          onChange={(e) => setActiveTab(e.target.value)}
          SelectProps={{ native: true }}
          size="small"
          fullWidth={isMobile}
        >
          <option value="all">All</option>
          <option value="buy">Buy</option>
          <option value="sell">Sell</option>
          <option value="redeem">Redeem</option>
        </TextField>

        {/* Refinery Dropdown */}
        <TextField
          id="refinery"
          label="Refinery"
          select
          value={refinery}
          onChange={(e) => setRefinery(e.target.value)}
          SelectProps={{ native: true }}
          size="small"
          fullWidth={isMobile}
        >
          <option value="all">All</option>
          <option value="augmont">Augmont</option>
          <option value="mmtc">MMTC</option>
        </TextField>

        {/* Metal Dropdown */}
        <TextField
          id="metalTypeId"
          label="Metal"
          select
          value={metaltype}
          onChange={(e) => setMetal(e.target.value)}
          SelectProps={{ native: true }}
          size="small"
          fullWidth={isMobile}
        >
          <option value="all">All</option>
          <option value="gold">Gold</option>
          <option value="silver">Silver</option>
        </TextField>
      </Box>

     
      {/* <Box display="flex" flexDirection={isMobile ? "column" : "row"} justifyContent={isMobile ? "flex-end" : "center"} alignItems="center" gap={2} mb={2}>
        <Box display="flex" alignItems="center" gap={1}>
          <InputLabel htmlFor="transactionType">Type</InputLabel>
          <TextField
            id="transactionType"
            select
            value={activeTab}
            onChange={(e) => setActiveTab(e.target.value)}
            SelectProps={{ native: true }}
            size="small"
          >
            <option value="all">All</option>
            <option value="buy">Buy</option>
            <option value="sell">Sell</option>
            <option value="redeem">Redeem</option>
          </TextField>
        </Box>

        <Box display="flex" alignItems="center" gap={1}>
          <InputLabel htmlFor="refinery">Refinery</InputLabel>
          <TextField
            id="refinery"
            select
            value={refinery}
            onChange={(e) => setRefinery(e.target.value)}
            SelectProps={{ native: true }}
            size="small"
          >
            <option value="all">All</option>
            <option value="augmont">Augmont</option>
            <option value="mmtc">MMTC</option>
          </TextField>
        </Box>

        <Box display="flex" alignItems="center" gap={1}>
          <InputLabel htmlFor="metalTypeId">Metal</InputLabel>
          <TextField
            id="metalTypeId"
            select
            value={metaltype}
            onChange={(e) => setMetal(e.target.value)}
            SelectProps={{ native: true }}
            size="small"
          >
            <option value="all">All</option>
            <option value="gold">Gold</option>
            <option value="silver">Silver</option>
          </TextField>
        </Box>
      </Box> */}

      <TransactionTable
        type={activeTab}
        refinery={refinery}
        metaltype={metaltype}
      />
    </Box>
  );
}


